import { QueryClient } from '@tanstack/react-query'

// Tách khỏi main.tsx để auth.ts xoá được cache khi đổi tài khoản/shop.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
    mutations: { retry: 0 },
  },
})
